import Fetch from './apiConfig/apiConfig';
import { ISubCategoryWithProductCount } from '../types';

export interface IGetSubCategoriesParams {
  [key: string]: any;
  categoryId: number;
  tradingGroups: string[];
}

export interface IGetSubCategoriesResponse {
  subcategories: ISubCategoryWithProductCount[];
}

export const getSubCategories = async (params: IGetSubCategoriesParams): Promise<ISubCategoryWithProductCount[]> => {
  const axios = await Fetch();
  const { data } = await axios.post<IGetSubCategoriesResponse>('products/subcategories', params);

  return data.subcategories;
};
